<div *ngIf="linkWhats" class="button__container">
	<p-button
		styleClass="p-button-raised p-button-rounded p-button-lg"
		icon="fa-brands fa-whatsapp"
		(onClick)="openWhats()"
	></p-button>
</div>
